import { register } from "@shopify/theme-sections";

register("header", {
  parseWeather: function () {
    const weatherInfo = JSON.parse(
      document.querySelector("[data-weather-data]").innerHTML
    );

    let keys = Object.keys(weatherInfo);

    keys.forEach((key) => {
      let singleWeather = weatherInfo[key];
      let utcOffset = parseInt(singleWeather.offset.replace("UTC", ""));
      let hoursUTC = new Date().getUTCHours();
      let minutesUTC = new Date().getUTCMinutes();
      let hoursWeather = hoursUTC + utcOffset;
      if (hoursWeather > 23) {
        hoursWeather = hoursWeather - 24;
        if (hoursWeather < 10) {
          hoursWeather = "0" + hoursWeather;
        }
      } else if (hoursWeather < 0) {
        hoursWeather = 24 + hoursWeather;
        if (hoursWeather < 10) {
          hoursWeather = "0" + hoursWeather;
        }
      }
      if (minutesUTC < 10) {
        minutesUTC = "0" + minutesUTC;
      }

      document.querySelector(
        ".header__weather-row"
      ).innerHTML += `<div class="header__weather-col">
          <small>${hoursWeather}:${minutesUTC}h</small>
          <strong>${singleWeather.temp}<sup>°</sup></strong>
          <p>${singleWeather.location}</p>
        </div>`;
    });
  },

  // Shortcut function called when a section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
  onLoad: function () {
    // Do something when a section instance is loaded
    let openNode = document.querySelector("[open-menu]");
    openNode.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("body")?.classList?.add("disable-scroll");
      document.querySelector(".header-mobile")?.classList?.add("active");
    });

    let closeNodes = document.querySelectorAll("[close-menu]");
    for (let i = 0; i < closeNodes.length; i++) {
      closeNodes[i].addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelector(".mobile-menu__submenu.active")
          ?.classList?.remove("active");
        document.querySelector("body")?.classList?.remove("disable-scroll");
        document.querySelector(".header-mobile")?.classList?.remove("active");
      });
    }

    let submenuOpenNode = document.querySelectorAll("[open-submenu]");
    for (let i = 0; i < submenuOpenNode.length; i++) {
      submenuOpenNode[i].addEventListener("click", function (e) {
        e.preventDefault();
        this.nextElementSibling?.classList?.add("active");
      });
    }

    let additionalMenu = document.querySelector(
      ".header-mobile-menu-additional"
    );
    var scrollBefore = 0;

    window.addEventListener("scroll", function (e) {
      const scrolled = window.scrollY;
      if (scrolled > 100) {
        if (
          scrollBefore > scrolled &&
          !additionalMenu?.classList?.contains("active")
        ) {
          scrollBefore = scrolled;
          additionalMenu.classList.add("active");
          //Desired action
        } else if (
          scrollBefore < scrolled &&
          additionalMenu.classList.contains("active")
        ) {
          scrollBefore = scrolled;
          additionalMenu.classList.remove("active");
          //Desired action
        }
      }
      if (
        scrolled > 0 &&
        scrolled < 300 &&
        this.document
          .querySelector("body")
          .classList.contains("template-product")
      ) {
        
        let scrollDiff = scrollBefore > scrolled ? 0 : scrolled > 30 ? 30 : scrolled;
        document.querySelectorAll(".header--submenu").forEach((submenu) => {
          submenu.style.top = 110 - scrollDiff + "px";
          submenu.style.height = "calc(100vh - " + (110 + scrollDiff) + ");";
        });
      };
      scrollBefore = scrolled;
    });

    document

      .querySelectorAll(".header--submenu--overlay")
      .forEach((overlay) => {
        overlay.addEventListener("click", () => {
          overlay.parentNode.parentNode.classList.add("remove-hover");
          setTimeout(() => {
            overlay.parentNode.parentNode.classList.remove("remove-hover");
            document.querySelector("body")?.classList?.remove("disable-scroll");
          }, 1000);
        });
      });

    //disable scrolling while top nav is open
    const menuContainer = document.querySelector(".header--list-menu");
    menuContainer.addEventListener(
      "mouseenter",
      () => {
        document.querySelector("body")?.classList?.add("disable-scroll");
      },
      false
    );

    const menuContainerItems = menuContainer.querySelectorAll(".header--list-menu li");
    menuContainerItems.forEach((item) => {
      item.addEventListener(
        "mouseenter",
        () => {
          item?.classList?.add("hovered-item");
          let itemSubmenu = item.querySelector('.header--submenu');
          if (itemSubmenu){
            itemSubmenu.addEventListener(
              "mouseenter",
              () => {
                item?.classList?.remove("hovered-item");
              },
              false
            );
          }
          
        },
        false
      );

      item.addEventListener(
        "mouseleave",
        () => {
          setTimeout(() => {
            item?.classList?.remove("hovered-item");
          }, 300);
        },
        false
      );

    })
    menuContainer.addEventListener(
      "mouseenter",
      () => {
        document.querySelector("body")?.classList?.add("disable-scroll");
      },
      false
    );

    menuContainer.addEventListener(
      "mouseleave",
      () => {
        document.querySelector("body")?.classList?.remove("disable-scroll");
      },
      false
    );

    let submenuCloseNode = document.querySelectorAll("[close-submenu]");
    for (let i = 0; i < submenuCloseNode.length; i++) {
      submenuCloseNode[i].addEventListener("click", function (e) {
        e.preventDefault();
        this.parentNode?.parentNode?.classList?.remove("active");
      });
    }

    let search_button = document.querySelector(".search__button");
    search_button.setAttribute("type", "button");
    search_button.addEventListener("click", function (e) {
      let form = search_button.parentNode;
      if (!form.hasAttribute("opened")) {
        form.setAttribute("opened", "");
        search_button.setAttribute("type", "submit");
        document.addEventListener(
          "click",
          function (e) {
            let path = e.composedPath();
            let searchFounded = false;
            for (let i = 0; i < path?.length; i++) {
              if (path[i]?.classList?.contains("search")) {
                searchFounded = true;
              }
            }
            if (!searchFounded && form.hasAttribute("opened")) {
              form.removeAttribute("opened");
              search_button.setAttribute("type", "button");
            }
          },
          false
        );
        e.preventDefault();
        return false;
      }
    });

    //weather
    let weatherItem = document.querySelector(".header--icon__weather");
    const toggleClass = (el, className) => el.classList.toggle(className);
    weatherItem.addEventListener("click", function (e) {
      e.preventDefault();
      toggleClass(weatherItem, "active");
    });

    this.parseWeather();
  },
});
